import { FrequencyChange } from "routes/schedule/compare/frequency-change"
import { DurationChange } from "routes/schedule/compare/duration-change"
import { registerTaskComparitor } from "routes/schedule/compare/register-task-comparitor"

registerTaskComparitor("frequency", () => <FrequencyChange label={`frequency`} path="frequency" />, true)

registerTaskComparitor("minutes", () => <DurationChange label={`duration`} path="minutes" />, true)
